import React, { useEffect } from "react";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import Printer from "../components/Printers/Printer";
import MerchantSyncButton from "../components/DashboardSideMenu/MerchantSyncButton";

function Printers() {
  const [printers, setPrinters] = React.useState(cloudStore.merchant.printers);

  function onChangeMerchant() {
    setPrinters([...cloudStore.merchant.printers]);
  }

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
  }, []);

  return (
    <div>
      <div>
        <MerchantSyncButton />
      </div>
      <div style={{ display: "flex", flexFlow: "wrap" }}>
        {printers.map((printer) => {
          return <Printer printer={{ ...printer }} />;
        })}
      </div>
    </div>
  );
}

export default Printers;
